import React, { createContext, useContext } from "react";

const DpatResultsLoadContext = createContext({
  reportMemoShown: () => {},
});

export function useDpatResultsLoad() {
  return useContext(DpatResultsLoadContext);
}

const DpatMemoAndScoresGate = ({ children }) => children;

export default DpatMemoAndScoresGate;
